export const overviewContent = {
  loadingLabel: 'Carregando visão geral da IA...',
  loadError: 'Não foi possível carregar a visão geral da IA.',
  providerTitle: 'Provedores',
  providerEmpty: 'Nenhum provedor conectado ainda.',
  providerDescription: 'Provedores disponíveis para respostas automáticas.',
  agentTitle: 'Agente IA',
  agentActive: 'Ativo',
  agentInactive: 'Inativo',
  agentMissing: 'Não configurado',
  agentMissingDescription: 'Configure um agente para iniciar os testes.',
  channelTitle: 'Canal',
  channelDescription: 'Disponível inicialmente para WhatsApp no plano Start.',
  knowledgeTitle: 'Base de conhecimento',
  knowledgeDescription: 'Conteúdos ativos para orientar respostas da IA.',
  nextStepTitle: 'Próximo passo recomendado',
  configureProviderTitle: 'Conecte um provedor de IA',
  configureProviderDescription:
    'Adicione uma chave de API para permitir que o Kraftchat gere respostas.',
  configureProviderAction: 'Ir para configuração',
  configureAgentTitle: 'Configure o agente IA',
  configureAgentDescription:
    'Defina o agente responsável pelo atendimento automático no canal permitido.',
  configureAgentAction: 'Configurar agente',
  activateAgentTitle: 'Ative o atendimento com IA',
  activateAgentDescription:
    'O agente já existe, mas ainda está inativo para atendimento automático.',
  activateAgentAction: 'Ativar agente',
  addKnowledgeTitle: 'Cadastre conteúdos na base',
  addKnowledgeDescription:
    'Adicione informações da empresa para melhorar a precisão das respostas.',
  addKnowledgeAction: 'Ir para base',
  readyTitle: 'Configuração inicial concluída',
  readyDescription:
    'A base inicial está pronta. O próximo passo é testar respostas antes de ativar o runtime real.',
  readyAction: 'Ir para testes',
};

export const getOverviewNextStep = ({
  providerCount,
  hasAgent,
  agentEnabled,
  activeKnowledgeCount,
}) => {
  if (!providerCount) {
    return {
      icon: 'i-lucide-key-round',
      title: overviewContent.configureProviderTitle,
      description: overviewContent.configureProviderDescription,
      actionLabel: overviewContent.configureProviderAction,
      routeName: 'kraftchat_ai_settings',
    };
  }

  if (!hasAgent) {
    return {
      icon: 'i-lucide-bot',
      title: overviewContent.configureAgentTitle,
      description: overviewContent.configureAgentDescription,
      actionLabel: overviewContent.configureAgentAction,
      routeName: 'kraftchat_ai_settings',
    };
  }

  if (!agentEnabled) {
    return {
      icon: 'i-lucide-power',
      title: overviewContent.activateAgentTitle,
      description: overviewContent.activateAgentDescription,
      actionLabel: overviewContent.activateAgentAction,
      routeName: 'kraftchat_ai_settings',
    };
  }

  if (!activeKnowledgeCount) {
    return {
      icon: 'i-lucide-book-open',
      title: overviewContent.addKnowledgeTitle,
      description: overviewContent.addKnowledgeDescription,
      actionLabel: overviewContent.addKnowledgeAction,
      routeName: 'kraftchat_ai_knowledge',
    };
  }

  return {
    icon: 'i-lucide-circle-check',
    title: overviewContent.readyTitle,
    description: overviewContent.readyDescription,
    actionLabel: overviewContent.readyAction,
    routeName: 'kraftchat_ai_playground',
  };
};
